module.exports = __webpack_public_path__ + "static/media/energycryptogirl.01907778.svg";